import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: "https://2632f67461ef37152853b52606190bb8@o4505264091889664.ingest.us.sentry.io/4505264095756288"
});
